import React from 'react';
import { Container, Col } from 'react-bootstrap';
import { useIntl, FormattedMessage } from 'react-intl';
import { useTheme } from "../context/ThemeContext";

import footerLogo from '../assets/img/PAYONE_Logo.svg';
import footerLogoWhite from '../assets/img/PAYONE_Logo_White.svg';
import CONSTANTS from '../utils/constants';
import './footer.css';

const Footer: React.FC = () => {
  const intl = useIntl();
  const { theme } = useTheme();

  return (
    <footer className="footer">
      <Container className="border-top border-secondary">
        <Col xs={12} className="content-section d-flex flex-column flex-sm-row align-items-center justify-content-between">

          <div className="d-flex logo">
            <a href="https://www.payone.com/" target="_blank" data-testid={`footer_logo`}>
              <img src={theme === "dark" ? footerLogoWhite : footerLogo} alt="Payone" className="footer-logo" />
            </a>
          </div>

          <ul className="list-unstyled d-flex">
            {CONSTANTS.FOOTER.LINKS.map((link, index) => (
              <li key={index}>
                <a
                  href={intl.formatMessage({ id: link.url, defaultMessage: "https://www.payone.com/DE-de/datenschutz" })}
                  className="text-primary text-decoration-none volte-medium"
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer_link_${index}`}
                >
                  <FormattedMessage id={link.label} />
                </a>
              </li>
            ))}
          </ul>

        </Col>
      </Container>
    </footer>
  );
}

export default Footer;